module.exports = __webpack_public_path__ + "static/media/fire.3ee01c35.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/fire.gif
// module id = 51
// module chunks = 0